import { HomeRoot } from './Home.styles'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { NutritionClaim } from './components/NutritionClaim'
import { Recipes } from './components/Recipes'
import { ReviewSlider } from '../components/ReviewSlider'
import { FamilyStory } from './components/FamilyStory'
import { CtaFooter } from './components/CtaFooter'
import { Footer } from 'components/Footer'
import { useObserver } from 'hooks/useObserver'
import { Testimonial } from './components/Testimonial/Testimonial'
import { HowItWorks } from './components/HowItWorks'
import { RealResults } from './components/RealResults'
import { LiveBetter } from './components/LiveBetter'
import { Hero } from './components/Hero'
import { Ingredients } from './components/Ingredients'
export const Home = () => {
  const header = <Header />
  const selector = 'button.cta'
  const hideCta = useObserver({ selector })

  return (
    <HomeRoot>
      <Layout header={header} hideCTA={hideCta}>
        <Hero />
        <HowItWorks variant='primary' />
        <LiveBetter />
        <Ingredients />
        <RealResults showBadge={true} />
        <Testimonial />
        <Recipes />
        <NutritionClaim />
        <ReviewSlider color='accent-white' background='secondary-500' />
        <FamilyStory />
        <CtaFooter title="home:ending.title" />
        <Footer />
      </Layout>
    </HomeRoot>
  )
}

Home.displayName = 'Home'
